<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="addWelcomeItem">添加</el-button>
        <el-button type="primary" @click="deleteWelcomeItem">批量删除</el-button>
      </el-col>
    </el-row>
    <SpFinder ref="finder" row-key="item_id" :split-count="10" :url="table_url" row-actions-width="200" :setting="setting"
      reserve-selection @select="handleSelectChange" @select-all="handleSelectAll" />
  </div>
</template>
<script>
import { welcomeTableSetting, commonAction } from '../config'
import { welcomeList, registerDelete } from '../api'
import { useDialog } from '@shopex/finder'

export default {
  props: {
    orgData: Object
  },
  data() {
    return {
      table_url: welcomeList,
      tableData: []
    }
  },
  computed: {
    setting() {
      return welcomeTableSetting(this)
    }
  },
  mounted() {

  },

  methods: {
    refresh() {
      this.$refs.finder.refresh()
    },
    handleSelectChange(data) {
      this.tableData = data
    },
    handleSelectAll(data) {
      this.tableData = data
    },
    deleteWelcomeItem() {
      if (this.tableData.length === 0) {
        this.$message.error('请选择要删除的欢迎语')
        return
      }

      this.$confirm('请确认是否批量删除？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          let ids = this.tableData.map(item => item.id)
          await registerDelete({ ids })
          this.$message.success('删除成功')
          this.refresh()
        })
    },
    addWelcomeItem() {
      useDialog(null, {
        title: `添加欢迎语`,
        width: '30%',
        component: () => import('./create.vue'),
        actions: commonAction
      }).then((arg) => {
        if (arg) {
          this.refresh()
        }
      })
    }
  }
};
</script>
<style scoped lang="scss">
.float-right {
  color: #1480e3;
  float: right;
}
</style>
